import React, { useState } from 'react';
import { servicesDropdown } from "../Components/DropdownNavItems"
import { Link } from 'react-router-dom';
import "../index.css"

const ServicesDropdown = () => {
    const [dropDown, setDropDown] = useState(false)
    return (
        <div>
            <>
                <ul className={dropDown ? "services-submenu clicked": "services-submenu"} onClick={() => setDropDown(!dropDown)}>
                    {
                        servicesDropdown.map(item => {
                            return (
                                <li key={item.id}>
                                    <Link to={item.path} className={item.cName} onClick={() => setDropDown(false)}>{item.title}</Link>
                                </li>
                            )
                        })
                    }
                </ul>
            </>
        </div>
    );
}

export default ServicesDropdown;
